// extracted by mini-css-extract-plugin
module.exports = {"divider":"ActivitiesCell_divider__qXgae","fullDivider":"ActivitiesCell_fullDivider__QAgNc","eventContainer":"ActivitiesCell_eventContainer__3PVV-"};